<template>
  <div class="home container-main">
    <my-header></my-header>
    <!-- <section id="home-top-section" class="gf-container padding--xl mar--t">
      <div class="columns is-gapless is-vcentered mobile-col-rev padding--l">
        <div class="column text-left padding--l-l txt--l">
          <div class="display--1 margin--element">
            On demand staffing platform
          </div>

          <div class="display--2 margin--element">
            We are reinventing the ways people will earn & learn in future.
          </div>

          <div class="display--3 gf-color--light">
            Our mission is to help people learn, earn, grow & enjoy their life!
          </div>

          <div class="py-4">
            <router-link to="/sign-up">
              <button
                class="button is-primary is-large"
                style="background-color: #d71f63"
              >
                Join Today
              </button>
            </router-link>

            <a :href="appUrl" class="ml-5" target="_blank">
              <img
                class="pointer"
                id="playstore"
                alt="App url"
                src="../assets/icon/play_store.png"
                width="50"
              />
            </a>
          </div>
        </div>

        <div class="column is-three-fifths">
          <img
            id="mainTitleImg"
            alt="happy part-time workers"
            src="../assets/title-section-image.png"
          />
        </div>
      </div>
    </section> -->
    <!-- how it works -->
    <!-- <section id="how-it-works">
      <div class="columns is-vcentered">
        <div class="column">
          <img
            class="creative"
            alt=""
            src="../assets/gigforce-creative-001.png"
          />
        </div>
        <div class="column text-col text-center" style="padding-right: 12%">
          <div class="pointers">
            <div class="title--1">
              {{ howItWorks.heading }}
            </div>
            <hr />
            <div class="display--3">
              {{ howItWorks.desc }}
            </div>

            <div
              class="pointer mt-6 mb-2"
              v-for="pointer of howItWorks.pointers"
              :key="pointer.heading"
            >
              <div class="columns ml-4 htw-card">
                <div class="column is-2 is-centered has-text-right">
                  <figure class="image is-48x48">
                    <img alt="" :src="pointer.imageSrc" />
                  </figure>
                </div>
                <div class="column">
                  <div class="display--2 dark">
                    {{ pointer.heading }}
                  </div>
                  <div class="display--3">
                    {{ pointer.desc }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section> -->

    <!-- benifits for you -->
    <!-- <section id="benefits-for-you">
      <div class="columns mobile-col-rev" >
        <div class="column is-half text-col text-center benefits-txt-container" >
          <div class="pointers text-left benefits-mt padding--xl" >
            <div class="title--1">
              {{ benefitsForYou.heading }}
            </div>   
               <hr  />

            <div class="title--2" style="margin: 60px 0px 15px 25px">
              {{ benefitsForYou.giger.heading }}
            </div>
            <div class="display--3 --light">
              <div style="margin: 0px 0px 15px 25px">
                {{ benefitsForYou.giger.desc1 }}
              </div>
              <div style="margin: 0px 0px 15px 25px">
                {{ benefitsForYou.giger.desc2 }}
              </div>
              <div style="margin: 0px 0px 15px 25px">
                {{ benefitsForYou.giger.desc3 }}
              </div>
            </div>

            <div class="title--2" style="margin: 60px 0px 15px 25px">
              {{ benefitsForYou.business.heading }}
            </div>
            <div class="display--3 --light">
              <div style="margin: 0px 0px 15px 25px">
                {{ benefitsForYou.business.desc1 }}
              </div>
              <div style="margin: 0px 0px 15px 25px">
                {{ benefitsForYou.business.desc2 }}
              </div>
              <div style="margin: 0px 0px 15px 25px">
                {{ benefitsForYou.business.desc3 }}
              </div>
              
            </div>
              
          </div>
       
        </div>

        <div style="text-align:right" class="column is-half">
         <img
            class="creative cash-img"
            alt=""
            src="../assets/Group-1919.png"
          />
        </div>
      </div>
    </section> -->

    <!-- Why Gig Model -->
    <!-- <section id="why-gig-Model">
      <div class="columns is-vcentered">
        <div class="column">
          <img class="creative" alt="" src="../assets/Group-1924.png" />
        </div>
        <div class="column text-col mar--t text-center">
          <div class="pointers padding--xl">
            <div class="title--1">
              {{ whyGigModel.heading }}
            </div>
            <hr />
            <div
              class="block pointer mt-4 mb-5"
              v-for="pointer of whyGigModel.pointers"
              :key="pointer"
            >
              <div class="item-holder is-flex-direction-row">
                <img
                  width="30"
                  class="only--desktop"
                  src="../assets/Group-1927.png"
                />
                <img
                  class="only--mobile checkpoint-mobile"
                  src="../assets/Group-1927.png"
                />

                <span class="display--3 pl-4 is-align-self-center">
                  {{ pointer }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section> -->

    <section class="section--spacing"></section>
    <!-- about us -->
    <section id="aboutUs" class="container">
      <div class="column">
        <div class="title--1 a-t-center">
          {{ aboutUs.heading }}
        </div>

        <div>
          <img alt="gigforce logo" class="logo" src="../assets/gigforce.png" />
        </div>
        <div class="is-size-3 mt-30 subheading a-t-center">
          {{ aboutUs.subheading }}
        </div>

        <div class="grpImg">
          <img alt="group img" height="600" src="../assets/Group-1923.png" />
        </div>
      </div>
    </section>

    <!-- team -->
    <section id="team" class="container padding--m--20" >
      <div class="text-left p--l--10">
        <div class="heading">
          {{ team.heading }}
        </div>
        <hr />
      </div>

        <div class="text-left p--l--10">
        <div class="subheading">
          {{ team.subheading }} 
        </div>
      </div>
       <div class="subheading">
           <!-- <hr/> -->
        </div>
  <section class="section--spacing"></section>
      <!-- <a href>
     <div class="text-left p--l--10">
         <span @click="goTosignUp()" class="subheading2" >
 
     {{ team.subheading2 }}  
           </span>
      </div>
      </a> -->

    <div>
        <div class="teammemberstyle" style="display:inline-block; height:400px; "
          v-for="(member, index) in team.members"  :key="index + 'team'" >
          <div  class="teamcard" >
              <!-- <div > -->
                <img style="margin-top:6%;margin-right:8%" class="imgstyle" :src="member.img" />
             <!-- </div> -->
          </div>
          <div class="teamcardtitlebox" >
            <div class="teamcardtitle">
              {{ member.name }}
            </div>
            <div class="teamcarddesignation">
              {{ member.designation }}
            </div>
            <div class="teamcarddesignationlinkedin ">
                  <a :href="member.linkedin" target="_blank" ><img src="img/icons/linkedin.png" alt="linkedin"/></a>
            </div>
          </div>
        </div>
    </div>

   
    <div v-if="allmembersshow">
        <div  class="teammemberstyle" style="display:inline-block; height:400px; "
          v-for="(member, index) in team.allmembers"  :key="index + 'team'" >
          <div  class="teamcard" >
              <!-- <div > -->
                <img style="margin-top:6%;margin-right:8%" class="imgstyle" :src="member.img" />
             <!-- </div> -->
          </div>
          <div class="teamcardtitlebox">
           
              <div class="teamcardtitle">
                {{ member.name }}
              </div>
              <div class="teamcarddesignation">
                {{ member.designation }}
              </div>
              <div class="teamcarddesignationlinkedin">
                    <a :href="member.linkedin" target="_blank" ><img src="img/icons/linkedin.png" alt="linkedin"/></a>
              </div>
 
          </div>
        </div>
    </div>


        <button class="button is-primary" style="margin-bottom:1%; margin-top:-2%; left:40%" v-if="!allmembersshow"  @click="showallteams()"> View All</button>
        <button class="button is-primary" style="margin-bottom:1%; margin-top:-2%; left:40%" v-if="allmembersshow"  @click="showallteams()"> View Less </button>

    
    </section>
    <my-footer></my-footer>
  </div>
</template>

<script>
var VueScrollTo = require("vue-scrollto");
import header from "../components/Header";
import footer from "../components/Footer";
import { playStoreURL } from "../service/config";

export default {
  name: "Home",
  metaInfo: {
    title: "Gigforce | Find highly qualified flexible staff in India easily",
    meta: [
      {
        name: "description",
        content:
          "Choose Gigforce as your complete workfoce management solution. Maximise profit by hiring pre-skilled workers, administration and payrolling for your operations.",
      },
    ],
  },
  data: () => ({
     allmembersshow:false,

    howItWorks: {
      heading: "How it works?",
      desc:
        "Gigforce helps you find work when and where you want based on your strengths to maintain your financial freedom.",
      imageSrc: "/img/creatives/gigforce-creative-signup.png",
      pointers: [
        {
          imageSrc: "/img/creatives/gigforce-creative-signup.png",
          heading: "Signup",
          desc:
            "Tell us about your skills and your work, and salary preferences.",
        },
        {
          imageSrc: "/img/creatives/gigforce-creative-explore.png",
          heading: "Explore",
          desc:
            "Explore your preferred gigs, other career options and network with other gigers.",
        },
        {
          imageSrc: "/img/creatives/gigforce-creative-learn.png",
          heading: "Learn",
          desc:
            "Advance your current skills or develop new ones on the learning platform in the app.",
        },
        {
          imageSrc: "/img/creatives/gigforce-creative-earn.png",
          heading: "Earn",
          desc: "Earn and have a career with us.",
        },
      ],
    },

    benefitsForYou: {
      heading: "Benefits for you",
      giger: {
        heading: "For Gigers",
        desc1: `Be your own boss`,
        desc2: `Learn and earn`,
        desc3: `have multiple careers`,
      },
      business: {
        heading: "For Businesses",
        desc1: `Just in-time hiring `,
        desc2: `Trained & engaged workforce`,
        desc3: `No paper work or payroll to manage`,
      },
    },

    aboutUs: {
      heading: `The on-demand staffing platform connecting businesses with flexible workers.`,
      subheading: `The future of staffing`,
    },
    team: {
      heading: "Our Team",
      subheading : "We are just a whisper away to hear from you.",
      subheading2 :"Get In Touch",
      members: [
        { name: "Chirag Mittal", designation: "Co founder and CEO", img: `img/team/Chirag_Mittal.png`, linkedin : "https://www.linkedin.com/in/chirag87/"},
        {name: "Anirudh Syal", designation: "Co founder and CPO",img: `img/team/Anirudh_Syal.png`,linkedin : "https://www.linkedin.com/in/anirudhsyal/"},
        {name: "Ankur Garg",designation: "Chief Operation Officer",img: `img/team/Ankur_Garg.png`,linkedin : "https://www.linkedin.com/in/ankurgarg5/" },
        {name: "Awadhesh Kumar",designation: "VP Operations",img: `img/team/awadhesh_kumar.png`,linkedin : "https://www.linkedin.com/in/awadhesh-kumar-03338322/"},
        {name: "Gautam Nath",designation: "SVP Sales",img: `img/team/gautam_nath.png`,linkedin : "https://www.linkedin.com/in/gautam-nath-855b101/" },{name: "Sahil Manchanda",designation: "Category Head",img: `img/team/sahil_manchanda.png`,linkedin : "https://www.linkedin.com/in/sahilmanchanda/"},
      ], 
      allmembers: [
        {name:'Manik Malhotra', designation:'VP Projects',img:'img/team/Manik_Malhotra.PNG',linkedin:'https://www.linkedin.com/in/malhotra-manik'},
        {name:'Reema Arora', designation:'Entrepreneur in Residence',img:'img/team/Reema_Arora.png',linkedin:'https://www.linkedin.com/in/reema-arora-97aaab25/'},
        {name:'Aakash Aggrawal', designation:'Associate Product Manager',img:'img/team/Aakash_Aggrawal.png',linkedin:'https://www.linkedin.com/in/aakashaggrawal/'},
        {name:'Komal Dhankhar', designation:'UX/UI Designer',img:'img/team/Komal_Dhankhar.png',linkedin:'https://www.linkedin.com/in/komal-dhankhar-979161193/'},
        // {name:'Divya Goel', designation:'Visual Designer',img:'img/team/Divya_Goel.jpeg',linkedin:'https://www.linkedin.com/in/divya-goel-375584132/'},
        {name:'Chahat Gupta', designation:'Product Success Associate',img:'img/team/Chahat_gupta.png',linkedin:'https://www.linkedin.com/in/chahat-g/'},
        {name:'Vipan Kumar', designation:'Senior Software Architect',img:'img/team/Vipan_Verma.png',linkedin:'https://www.linkedin.com/in/vipankverma/'},
        {name:'Vipin Mittal', designation:'Senior Software Architect',img:'img/team/Vipin_Mittal.jpeg',linkedin:'https://www.linkedin.com/in/vipin-mittal-973b3a60/'},
        {name:'Amit Dhiman', designation:'Android Developer',img:'img/team/Amit_Dhiman.png',linkedin:'https://www.linkedin.com/in/amit-dhiman-8200a5102/'},
        {name:'Himanshu Khati', designation:'Android Developer',img:'img/team/Himanshu_Khati.png',linkedin:'https://www.linkedin.com/in/him-khati/'},
        {name:'Jagdish Choudhary', designation:'Android Developer',img:'img/team/Jagdish_Choudhary.png',linkedin:'https://www.linkedin.com/in/jagdishchoudhary/'},
        {name:'Sarthak Chhabra', designation:'Web Developer',img:'img/team/Sarthak_Chhabra.png',linkedin:'https://www.linkedin.com/in/sarthak-chhabra/'},
        {name:'Ravi Prakash', designation:'Web Developer',img:'img/team/Ravi_Prakash.jpeg',linkedin:'https://www.linkedin.com/in/ravi-prakash-a6b843b4/'},
        {name:'Ankit Pal', designation:'Web Developer',img:'img/team/Ankit_Pal.png',linkedin:'https://www.linkedin.com/in/ankit-pal-3211b7ba/'},
        {name:'Rohit Pathak', designation:'Quality Assurance',img:'img/team/Rohit_pathak.png',linkedin:'https://www.linkedin.com/in/rohit-pathak-a7987731/'},
        {name:'Muskan Gupta', designation:'Human Resource',img:'img/team/Muskan_gupta.png',linkedin:'https://www.linkedin.com/in/muskang-1902/'},
        {name:'Shreya Jain', designation:'Human Resource',img:'img/team/Shreya_Jain.png',linkedin:'https://www.linkedin.com/in/shreya-jain9880/'},
        {name:'Vanshika Awasthi', designation:'Human Resource',img:'img/team/Vanshika_Awasthi.png',linkedin:'https://www.linkedin.com/in/vanshika-awasthi-461b5b74/'},
        // {name:'Ashok Kumar', designation:'AGM',img:'img/team/Ashok_Kumar.png',linkedin:'https://www.linkedin.com/in/ashok-kumar-a6b778100/'},
        {name:'Vividha Arya', designation:'Legal Associate',img:'img/team/Vividha_Arya.png',linkedin:'https://www.linkedin.com/in/vividha-arya-92672b123/'},
        // {name:'Arun Thapliyal', designation:'Program Manager',img:'img/team/Arun_Thapliyal.png',linkedin:'https://www.linkedin.com/in/arun-thapliyal-b82a7787/'},
        {name:'Ramanand Boddu', designation:'Service Delivery Lead',img:'img/team/Ramanand_Boddu.png',linkedin:'https://www.linkedin.com/in/bodduramanand/'},
        {name:'Venkata Chalapathi', designation:'Service Delivery Lead',img:'img/team/Venkat_Chalapathi.jpeg',linkedin:'https://www.linkedin.com/in/venkatachalapathi-narayanan-52b397184/'},
        // {name:'Debasis Mohanty', designation:'Service Delivery Lead',img:'img/icons/boyavtar.svg',linkedin:'https://www.linkedin.com/in/debasis-mohanty-1870374/'},
        {name:'Ayush Narway', designation:'Service Delivery Lead',img:'img/team/Ayush_Narway.png',linkedin:'https://www.linkedin.com/in/ayush-narway-638a8a2b/'},
        {name:'Kartikai Sisodia', designation:'Service Delivery Lead',img:'img/team/Kartikai_sisodia.png',linkedin:'https://www.linkedin.com/in/kartikai-sisodia-a4342959/'},
        {name:'Smit Khurana', designation:'Service Delivery Lead',img:'img/team/Smit_Khurana.png',linkedin:'https://www.linkedin.com/in/smitkhuranamdi/'},
        {name:'Rishabh Mishra', designation:'Service Delivery Lead',img:'img/team/Rishabh_Mishra.png',linkedin:'https://www.linkedin.com/in/rishabh-mishra-a8ba2391/'},
        {name:'Pratik Shah', designation:'Service Delivery Lead',img:'img/team/Pratik.png',linkedin:'https://www.linkedin.com/in/pratik-shah-a92ab1b7/'},
        {name:'Mujaheed Sharif', designation:'Service Delivery Lead',img:'img/team/mujaheed.png',linkedin:'https://www.linkedin.com/in/mujaheed-sharif-8298a574/'},
        // {name:'Priya Bharti', designation:'Service Delivery Lead',img:'img/icons/girlavtar.svg',linkedin:'https://www.linkedin.com/'},
        // {name:'Rijul Gupta', designation:'Operations Analyst ',img:'img/team/Rijul_Gupta.png',linkedin:'https://www.linkedin.com/in/rijul-gupta-0a1a0a19a/'},
      ]
    },

    whyGigModel: {
      heading: "Why Gig Model",
      pointers: [
        "More than 1 million gigers in top 10 metro cities",
        "Easy access to internet",
        "Mobile friendly work culture",
        "Increasing demand for flexible work days and time.",
        "Decreasing demand for permanent staff",
      ],
    },
    queryValue: "",
  }),
  methods: {
      goTosignUp() {
        this.$router.push({ name: "Signup" });
        setTimeout(() => {
          VueScrollTo.scrollTo("#sign-up", 1000);
        }, 1000);
      },
    goToPlayStore() {
      alert(JSON.stringify());
    },
    showallteams()
    {
      this.allmembersshow = !this.allmembersshow;
    } 
  },
  mounted() {
    for (let key of Object.keys(this.$route.query))
      this.queryValue += `&${key}=${this.$route.query[key]}`;

    // if(this.queryValue.length)
    //     this.queryValue[0] = '?'
  },
  computed: {
    appUrl: function(){
      return playStoreURL + this.queryValue
    },
  },
  components: {
    myFooter: footer,
    myHeader: header,
  },
};

</script>

<style lang="scss">
.home {
  font-family: "Poppins", sans-serif;
  color: rgb(24, 24, 24);
  overflow-x: hidden;
  margin-top: 8%;
}
.pointer {
  cursor: pointer;
}
.home-container {
  width: 80%;
  margin: 0 auto;
}

.text-left {
  text-align: left;
}

.is-48x48 {
  img {
    height: 48px;
    width: auto;
  }
}

#mainTitleImg {
  height: 498px;
}

#how-it-works {
  min-height: 500px;
  font-family: "Poppins", sans-serif;

  hr {
    margin-top: 2px;
    width: 130px;
    height: 3px;
    background-color: #d71f63;
  }
  .column {
    padding: 0;
    text-align: left;
  }

  .pointers {
    padding: 1rem;

    .pointer {
      display: block;
      .figure {
        width: 48px;
      }
      .heading {
        font-size: 24px;
        font-weight: bold;
      }

      .desc {
        font-size: 16px;
      }
    }
  }

  .creative {
    position: relative;
    left: 0px;
  }
}

#benefits-for-you {
  min-height: 500px;
  .text-col {
    margin-top: 5rem;
    padding-left: 60px;
  }
  hr {
    margin-top: 2px;
    width: 130px;
    height: 3px;
    background-color: #d71f63;
  }
  .column {
    padding: 0;
    text-align: left;
  }
  .section-desc {
    color: #93007c;
    font-weight: 500;
    margin-top: 30px;
  }
  .desc {
    font-size: 22px;
    font-weight: 300;
    line-height: 2;
    color: #647484;
  }

  .mt {
    margin-top: 100px;
  }
}
.benefits-mt {
  margin-top: 100px;
}
#why-gig-Model {
  min-height: 500px;
  font-family: "Poppins", sans-serif;

  hr {
    margin-top: 2px;
    width: 130px;
    height: 3px;
    background-color: #d71f63;
  }
  .column {
    padding: 0;
    text-align: left;
  }
  .points {
    font-size: 20px;
    font-weight: 500;
    letter-spacing: 1px;
    padding-bottom: 10px;
    margin-left: 10px;
  }
  .item-holder {
    display: flex;
    align-items: center;
  }
  .creative {
    position: relative;
    left: 0px;
  }
}

#aboutUs {
  margin-top: 30px;
  min-height: 500px;
  font-family: "Poppins", sans-serif;
  .logo {
    margin: 30px auto 0 auto;
    margin-top: 30px;
    width: 230px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .mt-30 {
    margin-top: 30px;
  }
  .subheading {
    color: #d71f63;
    font-weight: 700;
  }
  .grpImg {
    margin-top: 30px;
  }
}

#team {
  //min-height: 550px;
  font-family: "Poppins", sans-serif;
  margin-top: 80px;
 // margin-bottom: 30px;
 // text-align: left;
 
.teamcard
  {
    width: 280px;
    height: 270px;
    margin-right: 30px;
   // margin-inline: 5%;
   // left: 210px;
    top: 250px;
    background: #F2F4F5;
    box-shadow: 0px 0px 20px rgba(158, 154, 154, 0.15);
    border-radius: 12px;
  
  }
  .teamcardtitlebox
      {
        width: 280px;
        height: 90px;
        background: #FFFFFF;
        box-shadow: 0px 0px 24px rgba(216, 184, 194, 0.14);;
        border-radius: 12px;
     
      }
  .teamcardtitle
  {
    font-family: Lato;
    font-style: normal;
    font-weight: bold;
    font-size: 24px;
   // line-height: 25px;
    color: #202325;
    text-align:center; 
  }
  .teamcarddesignation
  {
      font-family: Lato;
      font-style: normal;
      font-weight: bold;
      font-size: 14px;
      line-height: 12px;
      color: #E42C64;
      text-align:ceneter; 
      margin-top: 0.5%; 
  }

    .teamcarddesignationlinkedin
  {
      font-family: Lato;
      font-style: normal;
      font-weight: bold;
      font-size: 14px;
      line-height: 12px;
      color: #E42C64;
      text-align:ceneter; 
      margin-top: 2%; 
  }

  
  .imgstyle{
      width: 230px;
      height: 230px;
      margin-left: 10%;    
      border-radius: 50%;
      border: 4px solid #FFFFFF;
      box-sizing: border-box;
      filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
  }
  .viewallbutton {
    width: 100%;
    height: 89px;
    background-color: rgba(#E42C64 ,0.2);;
   
    box-shadow: 0px 0px 12px rgba(158, 154, 154, 0.15);
    border-radius: 12px;
    margin-bottom:3%;
    font-family: Lato;
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    line-height: 29px;
    color:#E42C64;
    //opacity: 0.1;
  }
  .heading
  {
   // width: 231px;
    height: 58px;
    left: 145px;
    top: 66px;
    font-family: Lato;
    font-style: normal;
    font-weight: 500;
    font-size: 48px;
    line-height: 58px;
    letter-spacing: 0.08em;
    color: #202325;
  }
  .subheading
  {
   // width: 475px;
    height: 29px;
    left: 145px;
    top: 184px;
    font-family: Lato;
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    line-height: 29px;
    color: #202325;

    hr {
      position: absolute;
      width: 152px;
      top:104px;
      left:550px;
      border: 1px solid #E42C64 ;
      background-color: #E42C64;
    }
  }
  .subheading2
  {
    position: absolute;
    width: 259px;
    height: 29px;
    left: 719px;
    top: 92px;
    font-family: Lato;
    font-style: normal;
    font-weight: 900;
    font-size: 24px;
    line-height: 29px;
    letter-spacing: 0.195em;
    color: #E42C64;
    :hover 
    {
      color: #E42C64;
    }
  }



  hr {
    margin-top: 2px;
    width: 175px;
    top:144px;
    left:145px;
    
   // height: 3px;
    border: 2px solid #E42C64;
    background-color: #E42C64;
  }
  
  .column {
    margin-right: 20px;
  }
  .mt {
    margin-top: 10px;
  }

  .row {
    display: flex;
    text-align: center;
    justify-content: center;
  }
}

@media only screen and (max-width: 768px) {
  .htw-card {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .pointers {
    width: 90%;
    margin: 0 auto;
  }
  #mainTitleImg {
    width: 100%;
    height: unset;
  }

  #benefits-for-you {
    .text-col {
      margin-left: 1rem !important;
      margin-top: 2.3rem !important;
    }
  }
}
</style>